import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';
import { IconComponent } from '../icon/icon';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ui-file-upload',
  imports: [IconComponent],
  styleUrl: './file-upload.scss',
  templateUrl: './file-upload.html',
})
export class FileUploadComponent {
  /** Libellé affiché au-dessus de la zone. */
  readonly label = input('');

  /** Types MIME acceptés (ex. 'image/*,.pdf'). */
  readonly accept = input('');

  /** Autorise la sélection multiple. */
  readonly multiple = input(false);

  /** Texte d'aide. */
  readonly hint = input('');

  /** Désactive le composant. */
  readonly disabled = input(false);

  /** Émis avec la liste des fichiers sélectionnés (le parent gère la persistance). */
  readonly filesChange = output<File[]>();

  protected readonly files = signal<File[]>([]);
  protected readonly dragging = signal(false);

  protected onDragOver(event: DragEvent): void {
    if (this.disabled()) {
      return;
    }
    event.preventDefault();
    this.dragging.set(true);
  }

  protected onDragLeave(): void {
    this.dragging.set(false);
  }

  protected onDrop(event: DragEvent): void {
    event.preventDefault();
    this.dragging.set(false);
    if (this.disabled()) {
      return;
    }
    const dropped = Array.from(event.dataTransfer?.files ?? []);
    this.addFiles(dropped);
  }

  protected onSelect(event: Event): void {
    const target = event.target as HTMLInputElement;
    const selected = Array.from(target.files ?? []);
    this.addFiles(selected);
    target.value = '';
  }

  protected remove(index: number): void {
    this.files.update((list) => list.filter((_, i) => i !== index));
    this.filesChange.emit(this.files());
  }

  private addFiles(list: File[]): void {
    if (!this.multiple()) {
      this.files.set(list.slice(0, 1));
    } else {
      this.files.update((current) => [...current, ...list]);
    }
    this.filesChange.emit(this.files());
  }
}
